module.exports = __webpack_public_path__ + "static/img/bg8.bab017c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/year2023/bg8.png
// module id = 9OS0
// module chunks = 0